<template>
    <client-page class="wrap--login">
        <div class="container">
            <h2 class="login-title"><span>아이디 찾기</span></h2>

            <div class="login-container">
                <div class="login-rowgroup">
                    <div class="login-row login-row--button mt-0">
                        <v-text-field v-model="phone" outlined hide-details label="휴대전화번호" type="text" />
                        <v-btn @click="certify" color="primary" class="v-btn--input">인증번호전송</v-btn>
                    </div>
                    <div class="login-row mt-10 mt-md-16">
                        <v-text-field v-model="otp" outlined hide-details label="인증번호" type="number" />
                    </div>
                    <div class="login-row login-row--submit mt-16 mt-md-30">
                        <v-btn @click="recovery" block x-large color="primary">확인</v-btn>
                    </div>
                </div>
            </div>
        </div>
    </client-page>
</template>

<script>
import api from "@/api";
import ClientPage from "@/pages/client/templates/ClientPage.vue";

export default {
    components: {
        ClientPage,
    },
    data() {
        return {
            phone: null,

            otp: null,
        };
    },
    methods: {
        validate(recovery = false) {
            try {
                if (!this.phone) throw new Error("이메일을 입력해주세요");
                if (recovery && !this.otp) throw new Error("인증번호를 입력해주세요");

                return true;
            } catch (error) {
                alert(error.message);
            }
            return false;
        },

        async certify() {
            if (this.validate()) {
                let { phone } = this;
                await api.v1.users.certify.post({
                    type: "phone",
                    kind: "username",
                    phone,
                });

                alert("인증번호가 전송되었습니다");
            }
        },

        async recovery() {
            if (this.validate(true)) {
                let { phone, otp } = this;
                await api.v1.users.recovery.post({
                    type: "phone",
                    kind: "username",
                    phone,
                    otp,
                });

                alert("휴대전화번호로 아이디가 발송되었습니다");
            }
        },
    },
};
</script>
